import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { faAngleDoubleLeft, faSearch } from "@fortawesome/free-solid-svg-icons";
import SelectedPerson from "../Components/SelectedPerson";
import PoolPerson from "../Components/PoolPerson";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";
import "./IndicatorsInvitePeople.css";

function IndicatorsInvitePeople() {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [people, setPeople] = useState([]);
  const [filteredPeople, setFilteredPeople] = useState([]);
  const [type, setType] = useState("");
  const [filter, setFilter] = useState("");

  const { state } = useContext(AuthContext);

  let { iid } = useParams();

  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/invited/${state.userId}`,
        data: {
          indicatorId: iid,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      setPeople(response.data.users);
      setFilteredPeople(response.data.users);
      setSelectedPeople(response.data.selectedUsers);
      setType(response.data.type);
      setIsLoading(false);
    }
    fetch();
  }, [state.userId, state.token, iid]);

  const handleSelection = (id) => {
    let buffer = people.find((element) => element._id === id);

    let newPeopleArray = people.filter((element) => {
      return element._id !== id;
    });

    setSelectedPeople([...selectedPeople, buffer]);
    setPeople(newPeopleArray);
    setFilteredPeople(
      newPeopleArray.filter(
        (element) =>
          element.firstName.toLowerCase().includes(filter.toLowerCase()) ||
          element.lastName.toLowerCase().includes(filter.toLowerCase()),
      ),
    );
  };

  const handleBackToPool = (id) => {
    let buffer = selectedPeople.find((element) => element._id === id);

    let newSelectedPeopleArray = selectedPeople.filter((element) => {
      return element._id !== id;
    });

    setPeople([...people, buffer]);
    setFilteredPeople([...people, buffer]);
    setSelectedPeople(newSelectedPeopleArray);
  };

  const handleMassiveSelection = () => {
    setSelectedPeople([...selectedPeople, ...people]);
    setPeople([]);
    setFilteredPeople([]);
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const filterSearch = (e) => {
    if (filter !== "") {
      const filteredPeopleArray = people.filter(
        (element) =>
          element.firstName.toLowerCase().includes(filter.toLowerCase()) ||
          element.lastName.toLowerCase().includes(filter.toLowerCase()),
      );
      setFilteredPeople(filteredPeopleArray);
    } else {
      setFilteredPeople(people);
    }
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/update/invites/${iid}`,
        data: {
          selectedPeople: selectedPeople,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/myindicators");
    } catch (error) {
      setIsLoading(false);
      console.log(error.response.data.message);
    }
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col lg={7}>
            <Form>
              <Col className="header">
                <Row className="align-items-center">
                  <Col lg={12}>
                    <h5>{t("Indicadores.PersonasInvitadas")}</h5>
                  </Col>
                </Row>
              </Col>
              <Col className="selected-people">
                {selectedPeople.map((element) => (
                  <SelectedPerson
                    key={element._id}
                    id={element._id}
                    firstName={element.firstName}
                    lastName={element.lastName}
                    profile={element.profileName}
                    indicatorId={iid}
                    handleBackToPool={handleBackToPool}
                    type={type}
                  />
                ))}
              </Col>
              <Col className="category-buttons">
                <Button className="primary" onClick={handleSubmit}>
                  {t("Indicadores.Guardar")}
                </Button>
                <Link to="/indicators">
                  <Button className="danger">
                    {t("Indicadores.Cancelar")}
                  </Button>
                </Link>
              </Col>
            </Form>
          </Col>
          <Col lg={5} className="people-pool">
            <Col className="mb-4">
              <Row className="justify-content-left align-items-center">
                <Col lg={12}>
                  <h6>{t("Indicadores.PersonasDisponibles")}</h6>
                </Col>
                <Col lg={1}>
                  <FontAwesomeIcon
                    icon={faAngleDoubleLeft}
                    onClick={handleMassiveSelection}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row className="justify-content-left align-items-center">
                <Col lg={11}>
                  <Form.Control
                    type="text"
                    placeholder={t("Indicadores.BuscarPersona")}
                    onChange={(e) => handleFilterChange(e)}
                  />
                </Col>
                <Col lg={1} className="center">
                  <Button
                    className="primary search"
                    onClick={() => filterSearch()}
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col>
              {filteredPeople.map((element) => (
                <PoolPerson
                  key={element._id}
                  id={element._id}
                  firstName={element.firstName}
                  lastName={element.lastName}
                  profile={element.profileName}
                  handleSelection={handleSelection}
                />
              ))}
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default IndicatorsInvitePeople;
